module.exports = __webpack_public_path__ + "img/reset_light_step_2.23864c18.gif";